module.exports = __webpack_public_path__ + "img/68faf8bab8c4189ed370ba28c10eff5.5ae3cb36.jpg";